export default __webpack_public_path__ + "static/media/cto.ab8b63d2.png";